import React, {Component} from 'react';
import AuthenticatedTemplate from '../../Components/Templates/Authenticated';
import CreditCardInfo from "../../Components/CreditCardInfo/index";
import Modal from 'react-responsive-modal';
import {Grid} from 'tabler-react';

class CreditCard extends Component{

    state = {
        openModal:true
    }

    onCloseModal = () => {
        this.setState({openModal: false});
    }

    render() {
        return (
            <AuthenticatedTemplate title="Cartão de Credito">
                <Grid.Row>
                    <Grid.Col width="12" md="6">
                        <CreditCardInfo />
                    </Grid.Col>
                </Grid.Row>
                <Modal open={this.state.openModal} center onClose = {this.onCloseModal} >
                    <div className='modal-wrapper'>
                        <h1 style = {{width: "100%", textAlign: 'center'}}>IMPORTANTE!</h1>
                        <h3 style = {{width: "100%", textAlign: 'center'}}>Seu cartão de crédito precisa ficar ainda mais seguro no Ooppah!</h3>
                        <p style = {{width: "100%", textAlign: 'center'}}>Com o avanço dos hackers, nós também precisamos evoluir nossas ferramentas de proteção. <span style = {{fontWeight: "bold"}}>É fundamental que você recadastre o seu cartão e insira os dígitos verificadores.</span> </p>
                        <p style = {{width: "100%", textAlign: 'center'}}>Isto representa mais uma camada de proteção contra invasores mal intencionados. <span style = {{fontWeight: "bold"}}>Não se preocupe, as informações são criptografadas e ninguém, além da operadora de cartão, tem acesso a estes números.</span></p>
                        <p style = {{width: "100%", textAlign: 'center'}}>Esta atualização é obrigatória. O Ooppah não aceitará mais cartões sem os 3 dígitos verificadores. Isto é questão de segurança pra você e pra nós! Fique tranquilo!</p>
                        <p style = {{width: "100%", textAlign: 'center'}}>Ooppah, Seja Visto, com segurança!</p>
                    </div>
                </Modal>
            </AuthenticatedTemplate>
        );
    }
}

export default CreditCard;